/**
 * Segmented Pipeline | Corsie toggle for the ETL area. Mirrors the
 * Esecuzioni (WorkflowRunsPage) tab style. Corsie (lanes) intentionally has NO
 * sidebar entry — it's reached only through this switch, keeping the corsie UI
 * minimal (owner's call) while staying one click away from the pipelines list.
 */
import { useNavigate } from "react-router-dom";
import { Split, Workflow as PipeIcon } from "lucide-react";

import { cn } from "@/lib/cn";

export type EtlTab = "pipelines" | "lanes";

export function EtlNavTabs({ active }: { active: EtlTab }) {
  const navigate = useNavigate();
  const tab = (to: string, key: EtlTab, label: string, Icon: typeof PipeIcon) => (
    <button
      type="button"
      onClick={() => active !== key && navigate(to)}
      className={cn(
        "inline-flex items-center gap-1.5 rounded px-3 py-1",
        active === key ? "bg-muted font-medium" : "text-muted-foreground hover:text-foreground",
      )}
    >
      <Icon className="h-3.5 w-3.5" strokeWidth={1.5} /> {label}
    </button>
  );

  return (
    <div className="mb-4 inline-flex rounded-md border border-border p-0.5 text-sm">
      {tab("/etl", "pipelines", "Pipeline", PipeIcon)}
      {tab("/etl/lanes", "lanes", "Corsie", Split)}
    </div>
  );
}
